import { Editor, Element as SlateElement, Transforms } from 'slate'

import type { SlateBlock } from './types'

function isListBlock(block: SlateBlock): block is 'bulleted-list' | 'numbered-list' {
  return block === 'bulleted-list' || block === 'numbered-list'
}

export function isBlockActive(editor: Editor, block: SlateBlock): boolean {
  const { selection } = editor
  if (!selection) {
    return false
  }
  const [match] = Editor.nodes(editor, {
    at: Editor.unhangRange(editor, selection),
    match: node => !Editor.isEditor(node) && SlateElement.isElement(node) && node.type === block,
  })
  return match != null
}

export function toggleBlock(editor: Editor, block: SlateBlock): void {
  const active = isBlockActive(editor, block)
  Transforms.unwrapNodes(editor, {
    match: node => !Editor.isEditor(node) && SlateElement.isElement(node) && isListBlock(node.type),
    split: true,
  })
  const isList = isListBlock(block)
  Transforms.setNodes(editor, {
    type: active ? 'paragraph' : isList ? 'list-item' : block,
  })
  if (!active && isList) {
    Transforms.wrapNodes(editor, { type: block, children: [] })
  }
}
